module.exports = __webpack_public_path__ + "static/media/slime-busd.40d6a748.png";